export enum Datasources {
    ANIMANA = 'animana',
    DATAPOINT = 'datapoint-2020',
}
